export default __webpack_public_path__ + "static/media/a037-student-t3-1.e131ba81.svg";